<template>
   <div class="general-data-container">
      <div class="general-data-welcome-msg">
        <p class="welcome-title">Bienvenido al proceso de aplicación para ARTBO | Feria Internacional de Arte de Bogotá.</p>
        <p class="welcome-content">
          Después de una exitosa edición en 2018, con cerca de 32.000 asistentes e importantes resultados para las galerías participantes, ARTBO | Feria Internacional de Arte de Bogotá regresa en el 2019 en su aniversario número 15. Este año, la Feria cambiará sus fechas y tendrá lugar del 19 al 22 de septiembre de 2019 con una preinauguración el miércoles 18 de septiembre de 2019.
 
          Las galerías interesadas en participar en la sección Principal de ARTBO | Feria deberán llenar el siguiente formulario en línea.
           
          El registro se puede realizar hasta el 2 de Abril del 2019. Si tiene alguna duda o requiere más información, se puede comunicar con Felipe Villada, Jefe de Relaciones al correo felipe.villada@ccb.org.co o con Daniela Cortés, encargada de Relaciones con Galerías al correo daniela.cortes@ccb.org.co.
           
          SELECCIÓN
           
          Completar el formulario de aplicación no resultará en su admisión inmediata a ARTBO | Feria. Su participación será determinada por el Comité de Selección conformado por: (Elba Benítez (Galería Elba Benítez, España), Eduardo Brandão (Vermelho, Brasil), Beatriz López (Instituto de Visión, Colombia), Alex Mor (mor charpentier, Francia) y Leon Tovar (Leon Tovar Gallery, Estados Unidos)).
                  </p>
      </div>
      <div class="general-data-instructions">
        <p class="general-data-instructions-title">instrucciones</p>
        <p class="general-data-instructions-subtitle">DERECHOS DE INSCRIPCIÓN Y REGLAMENTO:</p>
        <p class="general-data-instructions-content">
          Los derechos de inscripción para ARTBO | Feria tienen un costo de USD 170, no reembolsables. Pague aquí .
 
          Tenga en cuenta que su proceso de aplicación no será válido hasta que realice el pago de sus derechos de inscripción, confirme que conoce y acepta el Reglamento de Participación en ARTBO | Feria, la reglamentación de pagos y la reglamentación de aduanas; y finalice la aplicación.
           
          PROCESO DE APLICACIÓN:
           
          Diligencie los siguientes campos:
           
          1. DATOS GENERALES: Información de contacto y facturación de su galería.
           
          2. LA GALERÍA: Descripción del perfil de la galería, su programación, artistas representados y participación en otras ferias.
           
          3. SELECCIÓN DE STAND: Opciones de stands disponibles con información de sus dimensiones, especificaciones técnicas y cantidad de artistas permitidos (del stand que elija, dependerá la cantidad de artistas que pueda incluir en su propuesta para ARTBO | Feria).
           
          4. PROPUESTA PARA ARTBO FERIA: Descripción de su propuesta artística para ARTBO y especificación de los artistas a presentar. 
           
          5. DOCUMENTACIÓN: Documentos requeridos para participar en ARTBO | Feria. Usted podrá cargar cada uno de esos documentos directamente en este formulario de aplicación. No es necesario que envíe estos documentos por correo.
           
          • Certificado de existencia (obligatorio para las galerías colombianas).
          • RUT o identificación fiscal.
          • Documento de identidad.
           
          6. PAGOS: Documentos de verificación de pago de sus derechos de inscripción requeridos para finalizar su aplicación.
           
          Nota: Le recordamos que el pago lo debe hacer con cuentas registradas a nombre de la empresa, razón social o personal natural asociada a los documentos que adjunte.
           
          7. REGLAMENTO Y PARTICIPACIÓN: Reglamento de Participación en ARTBO | Feria, Reglamentación de pagos y Reglamentación de obras nacionales e internacionales a ser aceptadas por el expositor.
           
          FINALIZACIÓN
           
          Revise en el checklist de Finalización que todos los campos hayan sido llenados exitosamente, y finalice su aplicación. Tenga en cuenta que una vez su aplicación haya sido finalizada, no podrá realizar cambios.
           
          GUARDAR LA INFORMACIÓN
           
          Para guardar la información, haga clic sobre el ícono “Guardar” en la parte superior derecha del formulario. Recuerde guardar en cada paso para evitar pérdidas de información.
        </p>

      </div>
    </div>  
</template>
<script>
  export default{
    name:'Information',
    data(){
      return{}
    }
  }
</script>
<style>
.general-data-container{
    padding: 0px 10vw;
    margin-top: 2%;
}
</style>